import { combineReducers } from 'redux';

import alerts from './alerts';
import filters, { customFilters } from './filters';
import intl from './intl';
import runtime from './runtime';
import schools from './schools';
import schoolsApplications from './schoolsApplications';
import page from './pagination';
import popup from './popup';
import user from './user';
import coachmarks from './coachmarks';
import goat from './goat';
import admissionProcesses from './admissionProcesses';
import admissionInstances from './admissionInstances';
import {
  schedulePrograms,
  appointments,
  studentAppointments,
  appointmentForm,
  cancelAppointmentForm,
  updateAppointmentForm,
  expressInterestForm,
  unexpressInterestForm,
  expressedInterests,
  noMatchingTimeSlots,
  noMatchingTimeSlotForm,
  sharedSchedules,
  scheduleCompletedForm,
  removeNoMatchingTimeSlotForm,
  expressedInterestsInstruments,
} from './scheduling';

export default () =>
  combineReducers({
    alerts,
    filters,
    customFilters,
    intl,
    runtime,
    schools,
    schoolsApplications,
    page,
    user,
    schedulePrograms,
    appointments,
    studentAppointments,
    appointmentForm,
    cancelAppointmentForm,
    updateAppointmentForm,
    expressInterestForm,
    unexpressInterestForm,
    expressedInterests,
    noMatchingTimeSlots,
    noMatchingTimeSlotForm,
    sharedSchedules,
    popup,
    coachmarks,
    scheduleCompletedForm,
    removeNoMatchingTimeSlotForm,
    goat,
    admissionProcesses,
    admissionInstances,
    expressedInterestsInstruments,
  });
